"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelListItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Title_1 = require("../../atoms/Typography/Title");
var Text_1 = require("../../atoms/Typography/Text");
var IconTitle_1 = require("../../atoms/IconTitle/IconTitle");
var utils_1 = require("../../../utils/utils");
var StyledLabelListItem = (0, styled_components_1.default)("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 20px;\n\n  .lms-icon-title {\n    margin-bottom: 5px;\n  }\n"], ["\n  margin-bottom: 20px;\n\n  .lms-icon-title {\n    margin-bottom: 5px;\n  }\n"])));
var LabelListItem = function (props) {
    var children = props.children, _a = props.variant, variant = _a === void 0 ? "header" : _a, title = props.title, icon = props.icon, _b = props.mobile, mobile = _b === void 0 ? false : _b, _c = props.className, className = _c === void 0 ? "" : _c;
    var theme = React.useContext(styled_components_1.ThemeContext);
    return ((0, jsx_runtime_1.jsx)(StyledLabelListItem, __assign({ className: "wellms-component ".concat(className) }, { children: variant === "header" ? ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [title &&
                    (React.isValidElement(title) ? (title) : ((0, jsx_runtime_1.jsx)(IconTitle_1.IconTitle, { level: mobile ? 5 : 4, title: typeof title === "string" ? title : "", icon: icon, as: "h1" }))), (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ noMargin: true, size: mobile ? "12" : "14", style: {
                        marginLeft: mobile ? "24px" : "0",
                    } }, { children: children }))] })) : ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ style: {
                        textTransform: "uppercase",
                        marginBottom: "8px",
                    }, size: "12" }, { children: title })), (0, jsx_runtime_1.jsx)(Title_1.Title, __assign({ level: 5, style: {
                        marginBottom: "0",
                        color: (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.dm__primaryColor, theme.primaryColor, theme.primaryColor),
                    }, as: "h1" }, { children: children }))] })) })));
};
exports.LabelListItem = LabelListItem;
// https://styled-components.com/docs/api#using-custom-props
var NewComponent = (0, styled_components_1.default)(exports.LabelListItem)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
// Main button with styles
exports.default = (0, styled_components_1.withTheme)(NewComponent);
var templateObject_1, templateObject_2;
